module.exports = __webpack_public_path__ + "assets/images/views/outro_PilotPin_ru.png";